import { styled } from '@mui/material';
import TextField, { TextFieldProps } from '@mui/material/TextField';
import { FC } from 'react';

import { theme } from '../../services/theme';

const StyledTextField = styled(TextField)({
  '& .MuiOutlinedInput-root': {
    '&:hover fieldset': {
      borderColor: '#356482',
    },
  },
});

export const Input: FC<TextFieldProps> = (props) => (
  <StyledTextField
    {...props}
    InputProps={{
      ...props.InputProps,
      sx: {
        height: 40,
        marginBottom: '2px',
        width: '100%',
        ...props?.InputProps?.sx,
      },
    }}
  />
);
